/**
*	@constructor Script used to define chartworks clipboard common functionality
*	@param copyButton: A copy button selector text (e.g. '.chartworks-clipboard-copy-btn')
*/
var ChartworksClipboard = function (copyButton) {
	this.copyButton = copyButton || '.chartworks-clipboard-copy-btn';
};

(function ($) {

	/**
	*	@description Method used to initialize ChartworksClipboard
	*/
	ChartworksClipboard.prototype.init = function () {
		// Check for valid copy button selector
		if (this.copyButton && this.copyButton.length > 0) {
			// Initialize code sample clipboard and success function
			new Clipboard(this.copyButton)
				.on('success', $.proxy(this.success, this))
				.on('error', $.proxy(this.error, this));
		}
	};

	/**
	*	@description Method triggered on clipboard success
	*/
	ChartworksClipboard.prototype.success = function (e) {
		var $copyButtonText = $(e.trigger).find('.btn-text');
		var copyButtonTextValue = $copyButtonText.text();

		// Clear selected text
		e.clearSelection();

		// Alert user that text has been copied
		$copyButtonText.text(window.cultureID === 'ja' ? 'コピーされた' : 'Copied');

		// Fade button text back to original state
		$copyButtonText.animate({ 'opacity' : 0 }, 2000, function () {
			var $this = $(this);

			$this.text(copyButtonTextValue);
			$this.css('opacity', 1);
		});
	};

	ChartworksClipboard.prototype.error = function (e) {
		console.error('Action:', e.action);
		console.error('Trigger:', e.trigger);
	};

})(jQuery);
